import React from "react";

// Botanical corner watermarks — vintage illustration overlays at very low opacity.
// Positioned absolutely inside the parent (which should be `relative overflow-hidden`).
// Uses subtle floating animation.

const BOTANICAL_URLS = {
  a: "https://images.unsplash.com/photo-1579167728798-a1cf3d595960?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwYm90YW5pY2FsJTIwaWxsdXN0cmF0aW9ufGVufDB8fHx8MTc4Mzk2NjMxNnww&ixlib=rb-4.1.0&q=85",
  b: "https://images.unsplash.com/photo-1584282000369-8b26844c9188?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHx2aW50YWdlJTIwYm90YW5pY2FsJTIwaWxsdXN0cmF0aW9ufGVufDB8fHx8MTc4Mzk2NjMxNnww&ixlib=rb-4.1.0&q=85",
};

export const BotanicalBackdrop = ({ variant = "corners" }) => {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      {variant === "corners" && (
        <>
          <img
            src={BOTANICAL_URLS.a}
            alt=""
            className="hk-float absolute -top-10 -left-10 w-[340px] md:w-[420px] opacity-[0.08] mix-blend-multiply select-none"
            style={{ filter: "sepia(0.4) hue-rotate(-10deg)" }}
          />
          <img
            src={BOTANICAL_URLS.b}
            alt=""
            className="hk-drift absolute -bottom-16 -right-12 w-[340px] md:w-[440px] opacity-[0.09] mix-blend-multiply select-none"
            style={{ filter: "sepia(0.3) hue-rotate(-5deg)" }}
          />
        </>
      )}
      {variant === "sideLeft" && (
        <img
          src={BOTANICAL_URLS.a}
          alt=""
          className="hk-float absolute top-1/2 -translate-y-1/2 -left-20 w-[380px] opacity-[0.07] mix-blend-multiply select-none"
          style={{ filter: "sepia(0.5)" }}
        />
      )}
      {variant === "sideRight" && (
        <img
          src={BOTANICAL_URLS.b}
          alt=""
          className="hk-drift absolute top-10 -right-16 w-[360px] opacity-[0.08] mix-blend-multiply select-none"
          style={{ filter: "sepia(0.4)" }}
        />
      )}
      {/* Gold hairline ornament in center */}
      {variant === "divider" && (
        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex justify-center">
          <div className="hk-divider w-full max-w-3xl">
            <LeafGlyph />
          </div>
        </div>
      )}
    </div>
  );
};

export const LeafGlyph = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    className={"w-5 h-5 " + className}
    aria-hidden="true"
  >
    <path
      d="M3 21c0-8 6-14 18-18-1 10-6 17-14 18a5 5 0 0 1-4-4Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 21c4-5 9-9 15-13" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export default BotanicalBackdrop;
